import { Wrap, WrapItem } from '@chakra-ui/react';
import { FC, memo } from 'react';
import isEqual from 'lodash/fp/isEqual';
import { FacebookShare, FacebookShareProps } from './FacebookShare';
import { EmailShare, EmailShareProps } from './EmailShare';
import { TwitterShare, TwitterShareProps } from './TwitterShare';
import { useSocial } from '../../hooks';

export type SocialShareProps =
  | FacebookShareProps
  | EmailShareProps
  | TwitterShareProps;

export type IsEmail = {
  body?: string;
  isEmailHasBody?: boolean;
};

export const SocialShare: FC<SocialShareProps & IsEmail> = memo(
  ({ url, isEmailHasBody = false, ...rest }: SocialShareProps & IsEmail) => {
    const { body } = rest;
    const { handleSharingIsCaringInteraction } = useSocial();
    const urlProp = url || '';
    return (
      <Wrap spacing={2} justify="center">
        <WrapItem onClick={handleSharingIsCaringInteraction}>
          <FacebookShare url={urlProp} {...rest} />
        </WrapItem>
        <WrapItem onClick={handleSharingIsCaringInteraction}>
          <EmailShare {...rest} url={isEmailHasBody ? body : urlProp} />
        </WrapItem>
        <WrapItem onClick={handleSharingIsCaringInteraction}>
          <TwitterShare url={urlProp} {...rest} />
        </WrapItem>
      </Wrap>
    );
  },
  isEqual
);
